import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-tecno-tournaments',
  templateUrl: './tecno-tournaments.KSA.component.html',
  styleUrls: ['./tecno-tournament-KSA.component.scss']
})
export class TecnoTournamentsKSAComponent implements OnInit {
  loadIndicator = false
  tournaments ;

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute();
    });
  }
  changeRoute() {
    this.loadIndicator = true;
    this.eventService.getEventTournaments('tecno-pubg-mobile-cup-2-saudi-arabia', 1, 'pubg').subscribe(res => {
      this.tournaments = res.data;
      this.loadIndicator = false;
      }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })
  }

}
